import { z } from 'zod';
import { DAY_OF_WEEK } from 'src/features/workingHours/utils/types';

export type WorkingHoursFormSchemaValues = z.infer<typeof workingHoursFormSchema>;
export const workingHoursFormSchema = z.object({
    all_day: z.boolean(),
    start_time: z.string().or(z.null()),
    end_time: z.string().or(z.null()),
    day_of_week: z.enum(DAY_OF_WEEK),
    zone: z.string().nonempty(),
});